import {
  LocalVideo,
  RemoteVideos,
  VideoGrid,
  useRemoteVideoTileState,
  useLocalVideo,
  useMeetingManager,
  UserActivityProvider,
} from "amazon-chime-sdk-component-library-react";
import {
  MeetingSessionConfiguration,
  DefaultMeetingSession,
  DefaultDeviceController,
  LogLevel,
  ConsoleLogger,
  TranscriptEvent,
} from "amazon-chime-sdk-js";
import AWS from "aws-sdk";
import { VideoTileGrid } from "amazon-chime-sdk-component-library-react";
import { Button, Space, Switch } from "antd";

import ChimeNoRemoteVideoView from "./ChimeNoRemoteVideoView";
import MeetingControls from "./MeetingControls";

import {
  ChimeSDKMediaPipelinesClient,
  CreateMediaLiveConnectorPipelineCommand,
} from "@aws-sdk/client-chime-sdk-media-pipelines";

import styled from "styled-components";
// import { MeetingData, ChannelData } from "./MeetingConfigDetails";

import {
  BotoMeetingDataConfig,
  // BotoMeetingData,
  // BotoAttendeeDataOne,
  // BotoAttendeeDataTwo,
  BotoAttendeeDataTwoConfig,
  BotoIVSChannelData,
  BotoAttendeeDataOneConfig,
  postMeetingCredits,
  postCreatePipeLine,
  transcriptionStart,
} from "./BotoMeetingConfigDetails";
import { useEffect } from "react";
import { IconRecord } from "Common/ReactIcons";
import utils from "utils";
import LoadingDots from "Components/Customdotloader/LoadingDots";
// interface Props {
//   showNav: boolean;
//   showRoster: boolean;
// }

const StyledLayout = styled.main`
  height: 100vh;
  width: 100%;

  display: grid;

  .video-content {
    grid-area: content;
  }

  ${({ showNav, showRoster }) => {
    if (showNav && showRoster) {
      return `
        grid-template-columns: auto auto 1fr;
        grid-template-areas: 'nav roster content';
      `;
    }

    if (showNav) {
      return `
        grid-template-columns: auto 1fr;
        grid-template-areas: 'nav content';
      `;
    }

    if (showRoster) {
      return `
        grid-template-columns: auto 1fr;
        grid-template-areas: 'roster content';
      `;
    }

    return `
      grid-template-columns: 1fr;
      grid-template-areas: 'content';
    `;
  }}

  .nav {
    grid-area: nav;
  }

  .roster {
    grid-area: roster;
    z-index: 2;
  }

  @media screen and (min-width: 769px) {
    .mobile-toggle {
      display: none;
    }
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-areas: "content";

    .nav {
      grid-area: unset;
      position: fixed;
    }

    .roster {
      grid-area: unset;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      max-width: 320px;
    }
  }

  @media screen and (max-width: 460px) {
    .roster {
      max-width: 100%;
    }
  }
`;

const StyledContent = styled.div`
  position: relative;
  grid-area: content;
  height: 100%;
  display: flex;
  flex-direction: column;

  .videos {
    flex: 1;
  }

  .controls {
    position: absolute;
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
  }

  @media screen and (max-width: 768px) {
    .controls {
      position: static;
      transform: unset;
    }
  }
`;

const ChimeMeetingPanel = ({
  meetingData,
  attendeeData,
  is_doctor,
  returnToLobby,
  remoteusr,
  remoteUserLastName,
  noRemoteVideoViewShow,
  patientDetail,
}) => {
  const meetingManager = useMeetingManager();
  const { toggleVideo, isVideoEnabled } = useLocalVideo();
  const { tiles } = useRemoteVideoTileState();
  const gridSize = isVideoEnabled ? tiles.length + 1 : tiles.length;
  const toggleVideoHandler = () => {
    toggleVideo(); // This will toggle the video on/off
  };

  const joinMeeting = async () => {
    const meetingSessionConfiguration = new MeetingSessionConfiguration(
      meetingData,
      attendeeData
    );

    await meetingManager.join(meetingSessionConfiguration);

    await meetingManager.start();
  };

  // const toggleAIForm = () => {
  //   meetingManager.audioVideo.transcriptionController?.subscribeToTranscriptEvent(
  //     (transcriptEvent) => {
  //       const transcriptResults = transcriptEvent?.results || [];
  //       console.log("############### TranscriptEvent ###############");
  //       console.log(transcriptEvent);
  //       console.log("##############################");

  //       console.log("###############Results###############");
  //       console.log(transcriptResults);
  //       console.log("##############################");

  //       // transcriptResults.forEach((result) => {
  //       //   console.log(result);
  //       //   console.log("result----->");
  //       //   if (!result.isPartial) {
  //       //     const transcriptionText = result.alternatives[0].transcript;
  //       //     console.log("Transcription:", transcriptionText);
  //       //     document.getElementById(
  //       //       "transcriptionText"
  //       //     ).innerText += `${transcriptionText}\n`;
  //       //   }
  //       // });
  //     }
  //   );
  // };

  useEffect(() => {
    // joinMeeting();
  }, []);

  return (
    <>
      <UserActivityProvider>
        <StyledLayout>
          <StyledContent>
            <VideoGrid
              style={{
                // height: "70vh"
                background: "#323232",
                height: "100%",
                width: "100%",
              }}
              layout="standard"
              // layout="featured"
              // noRemoteVideoView={}
              // noRemoteVideoView={
              //   <ChimeNoRemoteVideoView
              //     remoteusr={remoteusr}
              //     remoteUserLastName={remoteUserLastName}
              //   />
              // }
            >
              {/* {noRemoteVideoViewShow && (
                <ChimeNoRemoteVideoView
                  remoteusr={remoteusr}
                  remoteUserLastName={remoteUserLastName}
                />
              )} */}
              <div className="patient-info-div">
                <div className="patient-info">
                  <div>{`${remoteusr} ${remoteUserLastName}`}</div>
                  {is_doctor && (
                    <>
                      <div className="circle-div">
                        <div />
                      </div>
                      <div>{patientDetail?.age} Years</div>

                      <div className="circle-div">
                        <div />
                      </div>
                      <div>{utils.FormatName(patientDetail?.gender)}</div>
                      <div className="circle-div">
                        <div />
                      </div>
                      <div>
                        {utils.ConvertToPascalCase(patientDetail?.user_type)}
                      </div>
                    </>
                  )}
                </div>
                <div className="live-consult">
                  {noRemoteVideoViewShow ? (
                    <div style={{display:"flex"}}><div>Please wait to join</div><div style={{width:"5px"}}><LoadingDots/></div></div>
                  ) : (
                    <>
                      {" "}
                      <IconRecord />
                      <div>Live Consultation</div>
                    </>
                  )}
                </div>
              </div>

              <RemoteVideos />
              <LocalVideo
                nameplate="Me"
                css={`
                  border: 2.29px solid #8149EF;
                  border-radius: 9.14px;
                  display: -webkit-box;
                  display: -webkit-flex;
                  display: -ms-flexbox;
                  display: flex;
                  position: absolute !important;
                  bottom: 1rem;
                  left:1rem;
                  // right: 1rem;                  
                  // left: 24px;
                  // top: 584px;
                  // width: 20vw;
                  // max-height: 30vh;
                  // height: auto;
                  width: 240px;
                  height: 160px;
                  video {
                    position: static !important;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    width: 100%;
                    height: 100% !important;
                    object-fit: cover;}
                    .ch-nameplate {
                      -webkit-backdrop-filter: blur(20px);
                      backdrop-filter: blur(20px);
                      background-color: rgba(46, 47, 52, 0.85);
                      border-radius: 0.25rem;
                      bottom: 0.5rem;
                      color: #ffffff;
                      left: 0.5rem;
                      max-width: calc(100% - 2rem);
                      padding: 0.5rem;
                      position: absolute;
                    }
                  }
                `}
              />
            </VideoGrid>
            {/* <MeetingControls
              is_doctor={is_doctor}
              returnToLobby={returnToLobby}
              // configDetails={configDetails}
              // handleLeaveFunction={handleLeaveFunction}
            /> */}
          </StyledContent>
        </StyledLayout>
      </UserActivityProvider>
    </>
  );
};

export default ChimeMeetingPanel;
